import * as Yup from "yup";

const hasAlphanumeric = /[a-zA-Z0-9]/;
const invalidInputMessage = "Please enter a valid value";

const validationSchema = Yup.object().shape({
  company_name: Yup.string()
    .required("Company name is required")
    .matches(hasAlphanumeric, invalidInputMessage),
  Location: Yup.string()
    .required("Location is required")
    .matches(hasAlphanumeric, invalidInputMessage),
  company_overview: Yup.string()
    .required("Company overview is required")
    .matches(hasAlphanumeric, invalidInputMessage),
  job_title: Yup.string()
    .required("Job title is required")
    .matches(hasAlphanumeric, invalidInputMessage),
  job_description: Yup.string()
    .required("Job description is required")
    .test("has-alphanumeric-content", invalidInputMessage, (value) => {
      if (!value) return true;
      const text = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ");
      return hasAlphanumeric.test(text);
    }),
  qualification_id: Yup.number().required("Qualification ID is required"),
  skill_id: Yup.array()
    .of(Yup.string().required("This field is required"))
    .min(1, "At least one Skill is required"),
  job_type: Yup.string()
    .required("Job type is required")
    .matches(hasAlphanumeric, invalidInputMessage),
  timings: Yup.string()
    .required("Timings is required")
    .matches(hasAlphanumeric, invalidInputMessage),
  job_status: Yup.number().required("Job status is required"),
  job_posted: Yup.string().required("Job posted date is required"),
  last_date_apply: Yup.string().required("Last date to apply is required"),

  currency_id: Yup.string()
    .nullable()
    .test({
      test: function (value) {
        return this.parent.salary !== "" ? !!value : true;
      },
      message: "Select is required when salary is provided",
    }),
});

export default validationSchema;
